import React, {Component}from 'react'
import {connect} from 'react-redux'
import Title from "../../common/page-title/index"
import { getDataExports } from '../../../actions/data-export'
import irelandApi from '../../../irelandApi'
import FileDownload from 'react-file-download'
import './style.css';

class DataExport extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getDataExports());
  }

  renderLinks() {
    let links = [];

    this.props.data_exports.list.forEach(curr => {
      links.push(<div key={curr.label}>
        <a className="export-link"
           onClick={() => {this.downloadCSV(curr.url)}} >{curr.label}</a>
      </div>);
    });
    return links;
  }

  downloadCSV(url) {
    irelandApi.get(url)
              .then((response) => {
                FileDownload(response.data, 'export.csv');
              })
              .catch((error) => {

              })
  }



  render() {

    return (
      <div className="container-fluid data-export">

        <Title>Data Export</Title>

        <h4 className="storage-name">{this.props.data_exports.storage_name}</h4>

        { this.renderLinks() }

      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    data_exports: state.data_exports
  };
};

export default connect(mapStateToProps)(DataExport);


// WEBPACK FOOTER //
// ./src/components/admin/data-export/index.jsx